import { logger } from '@adornis/base/logging.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { Submission } from '../submission.js';

export const deleteSubmissionMutation = registerMutation({
  operationName: 'deleteSubmissionMutation',
  type: () => Boolean,
  params: [{ name: 'submissionId', type: () => String }],
  resolve: (submissionId: string) => async () => {
    const submissionCollection = await getCollection(Submission);

    const submissionToDelete = await submissionCollection.findOne({ _id: submissionId });

    if (!submissionToDelete) {
      throw new Error(`Submission mit ID ${submissionId} nicht gefunden.`);
    }

    await submissionCollection.deleteOne({ _id: submissionId });

    logger.info({ submissionId }, 'Submission wurde gelöscht.');

    return true;
  },
});
